<template>
	<div>
		<label v-if="!is_homework">
			<span class="l_title">Количество примеров: </span>
			<div class="plm">
				<div class="plm__button plm__button--minus" @click="addQnt('-', 'qnt')"></div>
				<input type="number" min="3" max="999999" :readonly="role == 'teacher' ? false : true" v-model="params.qnt">
				<div class="plm__button plm__button--plus" @click="addQnt('+', 'qnt')"></div>
			</div>
		</label>
		<div class="razd"></div>
		<label>
			<span class="l_title">Количество осей: </span>
			<div class="plm">
				<div class="plm__button plm__button--minus" @click="addQnt('-', 'to')"></div>
				<input type="number" min="1" max="8" :readonly="role == 'teacher' ? false : true" v-model="params.to">
				<div class="plm__button plm__button--plus" @click="addQnt('+', 'to')"></div>
			</div>
		</label>

		<div class="formulas" v-if="params.to == 1">
			<div class="razd"></div>
			<span class="l_title">Ограничение по цифрам:</span>
			<div class="mini_cifers">
				<label v-for="cif in [4,5,6,7,8,9]" class="mini_cifers" :class="cif < params.direct_to ? 'active' : ''">
					<input type="radio" :value="cif" v-model="params.direct_to">
					<span></span>
					<p>{{ cif }}</p>
				</label>
			</div>
			<div class="razd"></div>
		</div>

		<label v-show="!autoSettings">
			<span class="l_title">Направление: </span>
			<div class="sw_atn__body">
				<span class="sw_atn__check" :class="params.direction ? '' : 'active'">Число</span>
				<input type="checkbox" v-model="params.direction">
				<span class="sw_atn__round" :class="params.direction ? '' : 'active'"></span>
				<span class="sw_atn__check" :class="params.direction ? 'active' : ''">Абакус</span>
			</div>
		</label>

		<label v-show="!autoSettings">
			<span class="l_title">Режим: </span>
			<Select2 v-model="params.mode" :options="[{id: 'train', text: 'Тренировка'}, {id: 'fight', text: 'Испытания'}]" :settings="{multiple: false,minimumResultsForSearch: -1}" />
		</label>

		<label v-if="params.mode == 'fight'">
			<span class="l_title">Скорость (секунд):</span>
			<div class="plm">
				<div class="plm__button plm__button--minus" @click="addSpeed('-')"></div>
				<input type="number" min="0.1" max="0.1" :readonly="role == 'teacher' ? false : true" v-model="params.speed">
				<div class="plm__button plm__button--plus" @click="addSpeed('+')"></div>
			</div>
		</label>

		<div class="razd"></div>
		<label class="check_label" v-show="!autoSettings">
			<input type="checkbox" class="uk-checkbox" v-model="params.show_reactions">
			<span>Анимации</span>
		</label>

		<div class="modsettings__button" v-if="ingame">
			<button class="uk-button uk-button-primary" @click="apply">Применить</button>
		</div>
	</div>
</template>

<script>
  import Select2 from 'v-select2-component';
  import { mapState } from "vuex";

  export default {
    name: "settings",
    components: { Select2 },
    data() {
      return {
        params: '',
      }
    },
    watch: {
      params: {
        handler: function (newValue) {
          //console.log('Setting changed');
          if (!this.ingame) {
            this.$emit('params_changed', this.params);
          }
        },
        deep: true
      },
      'inparams': 'setParams'
    },
    computed: {
      ...mapState({
        item: 'current_trainer'
      }),
      role() {
        return this.$store.state.user.role.code;
      },

    },
    props: {
      inparams: '',
      ingame: '',
      is_homework: '',
      autoSettings: ''
    },
    methods: {
      apply() {
        this.$emit('params_changed', this.params);
        this.$parent.setShowsettings();
      },
      setParams() {
        if (this.inparams) {
          console.log('Has props params');
          this.params = this.inparams;
        } else {
          console.log('No props params');
          this.params = this.$store.state.train.flash_params;
        }
        this.checkHomework();
      },
      addSpeed(val) {
        let speed = +this.params.speed;
        if (val === '+' && speed < 5) {
          speed += 0.1;
        } else if (val === '-' && speed > 0.1) {
          speed -= 0.1;
        }

        this.params.speed = speed.toFixed(1);
      },
      addQnt(val, param, param2) {
        if (!param2) {
          if (val === '+') {
            this.params[param]++;
          } else if (this.params[param] > 1) {
            this.params[param]--;
          }
        } else {
          if (val === '+') {
            this.params[param][param2]++;
          } else if (this.params[param][param2] > 1) {
            this.params[param][param2]--;
          }
        }
      },
      checkHomework() {
        if (this.is_homework) {
          console.log('Это домашка!');
          //console.log(this.params.users);
          this.params.users = 1;
          this.params.qnt = 1;
        }
      }    },
    mounted() {
      //console.log('mounted settings');
      let app = this;
      setTimeout(function () {
        app.setParams();
      }, 200);
    }
  }
</script>
